import type React from 'react';

// Makes a clickable container (a whole row or card) reachable and operable
// from the keyboard and announced as a button. Enter/Space only act when the
// container itself has focus, so inner links and buttons keep working.
export function activatableProps(onActivate: () => void, label?: string) {
  return {
    role: 'button' as const,
    tabIndex: 0,
    ...(label && { 'aria-label': label }),
    onClick: onActivate,
    onKeyDown: (e: React.KeyboardEvent<HTMLElement>) => {
      if (e.target !== e.currentTarget) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onActivate();
      }
    },
  };
}
